export default class KeyNames {
  static BACKSPACE = "Backspace";

  static ENTER = "Enter";

  static ESCAPE = "Escape";

  static KEY_S = "s";

  static COMMA = ",";

  static SPACE = " ";
}
